// Single source for reading the `v5_csrf` cookie and building the CSRF header.
//
// The api client's csrfMiddleware (client.ts) adds X-CSRF-Token automatically
// to every openapi-fetch request. These helpers are for the handful of calls
// that bypass the typed client — multipart FormData uploads and a couple of
// reaction PUT/DELETEs use a raw `fetch`, so they must echo the token by hand.
// Before this, the same cookie-parse was copy-pasted ~9× across works/photos/
// forum/comments/users hooks (two slightly different forms). One home now.
// (cleanup audit 2026-06-15)

/** The decoded `v5_csrf` cookie value, or null (incl. during SSR / no cookie). */
export function csrfToken(): string | null {
  if (typeof document === 'undefined') return null;
  const m = document.cookie.match(/(?:^|; )v5_csrf=([^;]*)/);
  return m && m[1] !== undefined ? decodeURIComponent(m[1]) : null;
}

/** `{ 'X-CSRF-Token': <token> }` when a token is present, else `{}` — spread
 *  into a raw fetch's headers. */
export function csrfHeader(): Record<string, string> {
  const t = csrfToken();
  return t ? { 'X-CSRF-Token': t } : {};
}
